module.exports = __webpack_public_path__ + "img/header-bg.623c861d.png";